import { create } from "zustand";

import {
  SearchCloseMethod,
  SearchOpenMethod,
  trackSearchClosed,
  trackSearchOpened,
} from "@/lib/search-analytics";

interface NavigationSearchOpenStore {
  isOpen: boolean;
  openSearch: (method: SearchOpenMethod) => void;
  closeSearch: (method: SearchCloseMethod) => void;
  /** @deprecated Use openSearch/closeSearch instead for analytics tracking */
  setIsOpen: (isOpen: boolean) => void;
}

export const useNavigationSearchOpenStore = create<NavigationSearchOpenStore>(
  (set, get) => ({
    isOpen: false,

    openSearch: (method: SearchOpenMethod) => {
      if (!get().isOpen) {
        trackSearchOpened(method);
        set({ isOpen: true });
      }
    },

    closeSearch: (method: SearchCloseMethod) => {
      if (get().isOpen) {
        trackSearchClosed(method);
        set({ isOpen: false });
      }
    },

    // Keep for backwards compatibility, but prefer openSearch/closeSearch
    setIsOpen: (isOpen: boolean) => {
      const current = get();
      if (isOpen && !current.isOpen) {
        current.openSearch("click");
      } else if (!isOpen && current.isOpen) {
        current.closeSearch("click_outside");
      }
    },
  }),
);
